import React from 'react';

import moment from 'moment';

import TextButton from 'CommonComponents/TextButton';

import XMarkIcon from 'Assets/icons/xmark.svg';

/**
 * Whether an order is still open.
 *
 * Compared through parseInt on BOTH sides: the status is an int column and the
 * pending constant reaches the client as a string, so a strict comparison of
 * the two is always false. Exported so Home's unified list cannot get that
 * wrong separately.
 */
export const isPurchaseOrderPending = (row, pendingStatus) => parseInt(row.status, 10) === parseInt(pendingStatus, 10);

/**
 * One expenditure approval a user raised.
 *
 * Rendered by Home's unified My Requests list. `typeLabel` and `showValue` are
 * optional and additive — see UserRequestListPurchaseRequisitionsRow.
 */
export default function UserRequestListPurchaseOrdersRow({ row, typeLabel, showValue, rowClassName, isPending, onView, onCancel }) {
    return (
        <tr className={rowClassName}>
            <td className="tw-cursor-pointer inbud-date-cell" onClick={onView}>
                {moment(row.submission_date).format('DD-MM-YYYY')}
            </td>
            {!!typeLabel && (
                <td className="tw-cursor-pointer" onClick={onView}>
                    {typeLabel}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.purchase_requisition ? row.purchase_requisition.title : '-'}
            </td>
            {!!showValue && (
                <td className="tw-cursor-pointer inbud-numeric-cell" onClick={onView}>
                    {row.final_price}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.status_label}
            </td>
            <td>
                {isPending(row) && !row.canceled_at && (
                    <TextButton variant="danger" onClick={() => onCancel(row)}>
                        <XMarkIcon className="tw-w-3 tw-h-3" />
                        {$t('Cancel')}
                    </TextButton>
                )}
            </td>
        </tr>
    );
}
